import { log, supabase } from ".";

export const updateContrato = async ({ id, contrato }) => {
  try {
    const data = await supabase.update("sales_contratos", contrato, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    log.error("updateContrato", error);
    throw error;
  }
};
